/**
 * DR Gifts Email Eligibility (Dawn)
 *
 * Validates DRNEW eligibility via App Proxy and applies coupon when eligible.
 */
(function () {
  'use strict';

  if (window.__drGiftsEmailEligibilityMounted) return;
  window.__drGiftsEmailEligibilityMounted = true;
  const STATE = Object.freeze({
    guestManual: 'guest-manual',
    loggedInChecking: 'logged-in-checking',
    loggedInEligible: 'logged-in-eligible',
    loggedInUsed: 'logged-in-used',
    loggedInError: 'logged-in-error',
    applied: 'applied',
  });

  function getUiBridge() {
    return window.drCartGiftsUi || null;
  }

  function getConfig() {
    const modules = window.DR_GIFTS_CONFIG?.modules || {};
    if (modules.newMemberTab === false) return null;
    const cfg = window.DR_GIFTS_EMAIL;
    if (!cfg) return null;
    return {
      code: String(cfg.code || 'DRNEW').trim().toUpperCase(),
      endpoint: String(cfg.endpoint || '/apps/drnew/eligibility').trim(),
      successText: String(cfg.successText || '✅ קיבלת הנחה של 50% (DRNEW)'),
      usedText: String(cfg.usedText || 'כבר השתמשת בהטבה'),
      checkingText: String(cfg.checkingText || 'בודקות זכאות לחשבון שלך...'),
      eligibleText: String(cfg.eligibleText || 'החשבון שלך זכאי להטבת לקוחה חדשה.'),
      applyLabel: String(cfg.applyLabel || 'החלת DRNEW'),
      notEligibleText: String(cfg.notEligibleText || 'הקופון DRNEW לא זמין כרגע לחשבון זה.'),
      missingEmailText: String(cfg.missingEmailText || 'לא מצאנו אימייל לחשבון המחובר.'),
      applyErrorText: String(cfg.applyErrorText || 'לא הצלחנו להחיל את ההטבה כרגע.'),
      invalidText: String(cfg.invalidText || 'נא להזין כתובת אימייל תקינה'),
      errorText: String(cfg.errorText || 'משהו השתבש, נסה שוב'),
      timeoutMs: Math.max(1000, Number(cfg.timeoutMs) || 12000),
    };
  }

  function getWidget() {
    const uiBridge = getUiBridge();
    if (uiBridge?.getWidget) {
      return uiBridge.getWidget();
    }
    return document.querySelector('cart-drawer .dr-gifts[data-dr-gifts-widget], .dr-gifts[data-dr-gifts-widget]');
  }

  function getRoot() {
    return document.querySelector('cart-drawer [data-dr-email], [data-dr-email]');
  }

  function getLiveRoot(preferredRoot) {
    const currentRoot = getRoot();
    if (preferredRoot && preferredRoot.isConnected && (!currentRoot || preferredRoot === currentRoot)) {
      return preferredRoot;
    }
    return currentRoot || preferredRoot || null;
  }

  function getElements(root) {
    if (!root) return {};
    return {
      root,
      states: Array.from(root.querySelectorAll('[data-dr-email-state]')),
      checkingText: root.querySelector('[data-dr-email-checking-text]'),
      eligibleText: root.querySelector('[data-dr-email-eligible-text]'),
      usedText: root.querySelector('[data-dr-email-used-text]'),
      errorText: root.querySelector('[data-dr-email-error-text]'),
      applyButton: root.querySelector('[data-dr-email-apply]'),
      input: root.querySelector('[data-dr-email-input]'),
      submit: root.querySelector('[data-dr-email-submit]'),
      guestError: root.querySelector('[data-dr-email-error]'),
      successText: root.querySelector('[data-dr-email-success-text]'),
      accountLabels: Array.from(root.querySelectorAll('[data-dr-email-account]')),
    };
  }

  function isLoggedIn(root) {
    return root?.dataset?.loggedIn === 'true';
  }

  function getCustomerEmail(root) {
    return String(root?.dataset?.customerEmail || '').trim().toLowerCase();
  }

  function getCustomerId(root) {
    return String(root?.dataset?.customerId || '').trim();
  }

  function maskEmail(email) {
    const raw = String(email || '').trim().toLowerCase();
    const parts = raw.split('@');
    if (parts.length !== 2) return 'מחוברת לחשבון';
    const local = parts[0] || '';
    const domainParts = (parts[1] || '').split('.');
    const domainName = domainParts[0] || '';
    const tld = domainParts.length > 1 ? domainParts[domainParts.length - 1] : '';
    const localPrefix = local.slice(0, 2);
    const domainPrefix = domainName.slice(0, 2);
    if (tld) return `${localPrefix}***@${domainPrefix}***.${tld}`;
    return `${localPrefix}***`;
  }

  function getMaskedEmail(root) {
    const masked = String(root?.dataset?.customerEmailMasked || '').trim();
    if (masked) return masked;
    return maskEmail(getCustomerEmail(root));
  }

  function updateAccountLabels(els, value) {
    (els.accountLabels || []).forEach((el) => {
      el.textContent = value || 'מחוברת לחשבון';
    });
  }

  function clearGuestError(els) {
    if (!els?.guestError) return;
    els.guestError.textContent = '';
    els.guestError.classList.remove('is-used');
    els.guestError.setAttribute('hidden', '');
  }

  function showGuestError(els, message, isUsed) {
    if (!els?.guestError) return;
    els.guestError.textContent = String(message || '');
    els.guestError.classList.toggle('is-used', !!isUsed);
    els.guestError.removeAttribute('hidden');
  }

  function showState(root, stateKey) {
    const els = getElements(root);
    (els.states || []).forEach((stateNode) => {
      const isActive = stateNode.getAttribute('data-dr-email-state') === stateKey;
      stateNode.toggleAttribute('hidden', !isActive);
    });
  }

  function setMainButtonLoading(button, loading) {
    if (!button) return;
    button.disabled = !!loading;
    if (loading) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function setGuestLoading(els, loading) {
    setMainButtonLoading(els.submit, loading);
    if (els.input) els.input.disabled = !!loading;
  }

  function setApplyLoading(els, loading) {
    setMainButtonLoading(els.applyButton, loading);
  }

  function setConfigText(els, config) {
    if (!els || !config) return;
    if (els.checkingText) els.checkingText.textContent = config.checkingText;
    if (els.eligibleText) els.eligibleText.textContent = config.eligibleText;
    if (els.usedText) els.usedText.textContent = config.usedText;
    if (els.errorText) els.errorText.textContent = config.errorText;
    if (els.applyButton) els.applyButton.textContent = config.applyLabel;
  }

  function withTimeout(promise, timeoutMs, reason) {
    let timer = null;
    const timeout = new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error(reason || `timeout_${timeoutMs}`)), timeoutMs);
    });
    return Promise.race([promise, timeout]).finally(() => {
      if (timer !== null) clearTimeout(timer);
    });
  }

  function isTabActive(root) {
    // Compact layout shows DRNEW inside the club panel; any visible panel counts.
    const panel = root?.closest?.('[data-dr-panel]');
    if (panel) return !panel.hidden;
    const widget = root?.closest?.('[data-dr-gifts-widget]') || getWidget();
    if (!widget) return false;
    return widget.getAttribute('data-dr-active-tab') === 'new-customer';
  }

  async function fetchWithTimeout(url, request, timeoutMs) {
    if (typeof AbortController === 'undefined') {
      return fetch(url, request);
    }

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
      return await fetch(url, {
        ...request,
        signal: controller.signal,
      });
    } catch (err) {
      if (err?.name === 'AbortError') {
        throw new Error(`request_timeout_${timeoutMs}`);
      }
      throw err;
    } finally {
      clearTimeout(timer);
    }
  }

  async function requestEligibility(config, payload) {
    const response = await fetchWithTimeout(config.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }, config.timeoutMs);
    if (!response.ok) throw new Error('eligibility_http_' + response.status);
    return response.json();
  }

  function markAutoCheckDone(root) {
    if (!root) return;
    root.dataset.autoCheckDone = 'true';
  }

  function isAutoCheckDone(root) {
    return root?.dataset?.autoCheckDone === 'true';
  }

  function showApplied(root, text) {
    const els = getElements(root);
    clearGuestError(els);
    // The compact layout draws the brand check icon itself; drop the emoji.
    const shown = root?.closest?.('.dr-gifts--compact') ? String(text || '').replace(/^\s*✅\s*/, '') : text;
    if (els.successText) els.successText.textContent = shown;
    showState(root, STATE.applied);
  }

  async function applyDiscount(code, config) {
    const reconciler = window.drGiftsReconciler;
    if (!reconciler?.applyDiscountCode) throw new Error('reconciler_missing');
    const timeoutMs = config?.timeoutMs || 12000;
    const result = await withTimeout(
      reconciler.applyDiscountCode(code, { mode: 'append', timeoutMs }),
      timeoutMs,
      'apply_timeout'
    );
    if (!result?.success) throw new Error('apply_failed');
  }

  async function handleGuestSubmit() {
    const config = getConfig();
    const root = getRoot();
    const els = getElements(root);
    if (!config || !root || !els.input || !els.submit) return;

    const email = String(els.input.value || '').trim().toLowerCase();
    clearGuestError(els);

    if (!email) {
      els.input.focus();
      return;
    }

    if (!els.input.checkValidity()) {
      els.input.setCustomValidity(config.invalidText);
      els.input.reportValidity();
      return;
    }

    setGuestLoading(els, true);
    try {
      const data = await requestEligibility(config, { email });

      if (data?.eligible) {
        await applyDiscount(config.code, config);
        showApplied(root, config.successText);
        return;
      }

      if (data?.alreadyUsed) {
        showGuestError(els, config.usedText, true);
        return;
      }

      showGuestError(els, config.usedText, true);
    } catch (err) {
      console.error('[DR Gifts Email] Error:', err);
      showGuestError(els, config.errorText, false);
    } finally {
      setGuestLoading(els, false);
    }
  }

  async function runLoggedInAutoCheck(root, opts = {}) {
    const config = getConfig();
    const els = getElements(root);
    if (!config || !root || !isLoggedIn(root)) return;
    if (!isTabActive(root)) return;
    if (!opts.force && isAutoCheckDone(root)) return;
    // DRNEW is already in the cart (the server rendered its applied line): a
    // check would only swap that line for "eligible" or "used".
    if (root.querySelector(`[data-dr-email-state="${STATE.applied}"]:not([hidden])`)) {
      markAutoCheckDone(root);
      return;
    }

    const email = getCustomerEmail(root);
    const customerId = getCustomerId(root);
    if (!email) {
      if (els.errorText) els.errorText.textContent = config.missingEmailText;
      showState(root, STATE.loggedInError);
      markAutoCheckDone(root);
      return;
    }

    showState(root, STATE.loggedInChecking);
    try {
      const data = await requestEligibility(config, { email, customerId });
      const liveRoot = getLiveRoot(root);
      const liveEls = getElements(liveRoot);
      if (!liveRoot || !isTabActive(liveRoot)) return;
      if (data?.alreadyUsed) {
        if (liveEls.usedText) liveEls.usedText.textContent = config.usedText;
        showState(liveRoot, STATE.loggedInUsed);
      } else if (data?.eligible) {
        if (liveEls.eligibleText) liveEls.eligibleText.textContent = config.eligibleText;
        showState(liveRoot, STATE.loggedInEligible);
      } else {
        if (liveEls.usedText) liveEls.usedText.textContent = config.notEligibleText;
        showState(liveRoot, STATE.loggedInUsed);
      }
      markAutoCheckDone(liveRoot);
    } catch (err) {
      console.error('[DR Gifts Email] Logged-in eligibility check failed:', err);
      const liveRoot = getLiveRoot(root);
      const liveEls = getElements(liveRoot);
      if (liveEls.errorText) liveEls.errorText.textContent = config.errorText;
      showState(liveRoot, STATE.loggedInError);
      markAutoCheckDone(liveRoot);
    }
  }

  async function handleLoggedInApply() {
    const config = getConfig();
    const root = getRoot();
    const els = getElements(root);
    if (!config || !root || !isLoggedIn(root) || !els.applyButton) return;

    setApplyLoading(els, true);
    try {
      await applyDiscount(config.code, config);
      showApplied(getLiveRoot(root), config.successText);
    } catch (err) {
      console.error('[DR Gifts Email] Logged-in apply failed:', {
        reason: err?.message || String(err),
        timeoutMs: config.timeoutMs,
      });
      const email = getCustomerEmail(root);
      const customerId = getCustomerId(root);
      try {
        const data = await requestEligibility(config, { email, customerId });
        const liveRoot = getLiveRoot(root);
        const liveEls = getElements(liveRoot);
        if (data?.alreadyUsed) {
          if (liveEls.usedText) liveEls.usedText.textContent = config.usedText;
          showState(liveRoot, STATE.loggedInUsed);
        } else {
          if (liveEls.errorText) liveEls.errorText.textContent = config.applyErrorText;
          showState(liveRoot, STATE.loggedInError);
        }
      } catch (_) {
        const liveRoot = getLiveRoot(root);
        const liveEls = getElements(liveRoot);
        if (liveEls.errorText) liveEls.errorText.textContent = config.applyErrorText;
        showState(liveRoot, STATE.loggedInError);
      }
    } finally {
      setApplyLoading(getElements(getLiveRoot(root)).applyButton || els.applyButton, false);
    }
  }

  function maybeAutoCheck() {
    const root = getRoot();
    const config = getConfig();
    if (!root || !config) return;
    const els = getElements(root);
    setConfigText(els, config);
    updateAccountLabels(els, getMaskedEmail(root));
    if (isLoggedIn(root)) {
      runLoggedInAutoCheck(root);
    }
  }

  function bindEvents() {
    const config = getConfig();
    if (!config) return;

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('[data-dr-email-submit]');
        if (!button) return;
        if (!getRoot()) return;
        event.preventDefault();
        event.stopPropagation();
        handleGuestSubmit();
        return;
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const apply = event.target.closest('[data-dr-email-apply]');
        if (!apply) return;
        if (!getRoot()) return;
        event.preventDefault();
        event.stopPropagation();
        handleLoggedInApply();
        return;
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const tab = event.target.closest('[data-dr-tab]');
        if (!tab) return;
        requestAnimationFrame(() => {
          maybeAutoCheck();
        });
      },
      true
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Enter') return;
        const input = event.target.closest('[data-dr-email-input]');
        if (!input || !getRoot()) return;
        event.preventDefault();
        event.stopPropagation();
        handleGuestSubmit();
      },
      true
    );

    document.addEventListener(
      'input',
      (event) => {
        const input = event.target.closest('[data-dr-email-input]');
        if (!input) return;
        input.setCustomValidity('');
        clearGuestError(getElements(getRoot()));
      },
      true
    );

    document.addEventListener(
      'invalid',
      (event) => {
        const input = event.target.closest?.('[data-dr-email-input]');
        if (!input) return;
        input.setCustomValidity(config.invalidText);
      },
      true
    );

    document.addEventListener(
      'pointerdown',
      (event) => {
        if (event.target.closest('[data-dr-email]')) {
          event.stopPropagation();
        }
      },
      true
    );
  }

  function observeTabChanges() {
    const widget = getWidget();
    if (!widget) return;
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-dr-active-tab') {
          maybeAutoCheck();
        }
      }
    });
    observer.observe(widget, { attributes: true, attributeFilter: ['data-dr-active-tab'] });
  }

  function init() {
    const config = getConfig();
    if (!config) return;
    const root = getRoot();
    if (root) {
      const els = getElements(root);
      setConfigText(els, config);
      updateAccountLabels(els, getMaskedEmail(root));
    }
    bindEvents();
    observeTabChanges();
    maybeAutoCheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
